export default {
  'pages.orderNo.table.title': 'Order Number Config',
  'pages.orderNo.subTitle': 'Manage prefixes for different order types',
  'pages.orderNo.table.columns.type': 'Type',
  'pages.orderNo.table.columns.prefix': 'Prefix',
  'pages.orderNo.table.columns.description': 'Description',
  'pages.orderNo.table.columns.operations': 'Operations',
  'pages.orderNo.actions.edit': 'Edit',
  'pages.orderNo.message.loadFailed': 'Failed to load data',
  'pages.orderNo.message.missingRecord': 'Missing record',
  'pages.orderNo.message.updateSuccess': 'Updated successfully',
  'pages.orderNo.message.updateFailed': 'Update failed',
  'pages.orderNo.form.editTitle': 'Edit Order Number Config',
  'pages.orderNo.form.typeLabel': 'Type',
  'pages.orderNo.form.prefixLabel': 'Prefix',
  'pages.orderNo.form.prefixRequired': 'Please enter prefix',
  'pages.orderNo.form.prefixMaxLength': 'Prefix cannot exceed 50 characters',
  'pages.orderNo.form.prefixPlaceholder': 'Please enter prefix',
  'pages.orderNo.form.descriptionLabel': 'Description',
};
